import { tasksId } from "../../../types/activityTasks";
import { completeOneTask } from "../../../store/slices/menu/tunks";
import { BarStatusActivies } from "../../../components/common/BarStatusActivies";
import React, { useEffect, useState } from "react";
import ObserverEmitter, { EVENTS } from "../../../emitter/Observer";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useGetActivitiesBySubTopic } from "../../../hooks/useGetActivitiesBySubTopic";
import { DialogBarNew } from "../../../components/common/DialogBarNew";
import { HeaderRedPresentation } from "../../../components/common/HeaderRedPresentation";
import { PanelActivities } from "../../../components/common/PanelActivities";
import { ValidationResultModal } from "../../../components/common/ValidationResultModal";
import { ButtonPlay } from "../../../components/common/ButtonPlay";
import { ButtonHome } from "../../../components/common/ButtonHome";
import { audiosAssets } from "../../../assets/audio";
import { imgsTopic4 } from "../../../assets/imgs/Tema4";
import { voicesTypeControl } from "../../../types/audioType";
import { ButtonReturn } from "../../../components/common/ButtonReturn";

const steps = {
	dialogOne: 1,
	viewActivities: 2,
	cardOne: 3,
	cardTwo: 4,
	cardThree: 5,
	win: 6,
}
export const Tema4SubtopicSixActivityOne = () => {
	const dispatch = useDispatch();
	const navigation = useNavigate();
	const { loaded, activitiesInformation } = useSelector((state) => state.menu);
	const [uiToShow, setUiToShow] = useState(1);
	const { tasksList, points } = useGetActivitiesBySubTopic(activitiesInformation[tasksId.tema4.activities.subtema6], 1);
	useEffect(() => {
		if (loaded) {
			console.log("tema 4 subtema6 activity 1");
			ObserverEmitter.emit(EVENTS.tema4.subtopicSix.initScene, 1);
			ObserverEmitter.emit(EVENTS.audiosEvents.pauseActive, true)
			ObserverEmitter.emit(EVENTS.audiosEvents.createAudioScene, audiosAssets.escenarios.selectCharacterScene)
		}
	}, [loaded]);
	ObserverEmitter.on(EVENTS.audioInitByTopic, () => {
		ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T4.sub06.sub6_act1_a01)
	})
	return (
		<>
			<>
				<ButtonPlay />
				<ButtonHome />
				{![1].includes(uiToShow) && (
					<ButtonReturn callback={() => {
						ObserverEmitter.emit(EVENTS.tema4.subtopicSix.initScene, 1);
						setUiToShow(1)
					}} />
				)}
			</>
			{uiToShow === steps.dialogOne && (
				<>
					<HeaderRedPresentation name="Actividad 1: Etapas del Lavado de Dinero." />
					<DialogBarNew
						dialog={
							"Ahora, exploraremos las etapas del lavado de dinero para que puedas identificar las más comunes."
						}
						callback={() => {
							setUiToShow(steps.viewActivities);
							ObserverEmitter.emit(EVENTS.audiosEvents.controlVoices, voicesTypeControl.stop)
						}}
					></DialogBarNew>
				</>
			)}
			{uiToShow === steps.viewActivities && (
				<>
					<PanelActivities
						buttonText="¡Comenzar!"
						title="Subtema 6: Lavado de dinero"
						titleActivity="Actividades por realizar:"
						points={points}
						insigniaBackground={0}
						actionButton={() => {
							ObserverEmitter.emit(EVENTS.tema4.subtopicSix.activityOne.moveCamera)
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T4.sub06.sub6_act1_a02)
							setUiToShow(steps.cardOne);
						}}
						activities={tasksList}
					/>
				</>
			)}
			{uiToShow === steps.cardOne && (
				<>
					<BarStatusActivies activities={tasksList} />
					<div className="fixed z-10 bg-[#00000074] h-full w-full"></div>
					<div className="fixed z-10 h-full w-full pt-12 flex justify-center items-center">
						<div className="w-[224px] h-[280px] md:w-[450px] md:h-[600px] gradiantBlueClient rounded-2xl border-[1px] border-white p-2">
							<div className="bg-red_primary w-full h-[32px] md:h-[40px] rounded-lg flex justify-center items-center">
								<p className="text-white text-[14px] md:text-[24px]">Colocación</p>
							</div>
							<div className="h-[calc(100%-32px)] md:h-[calc(100%-40px)] md:p-7">
								<div className="w-full h-full py-3">
									<img className="h-full w-full object-contain" src={imgsTopic4.manCardOne} alt="Hombre al telefono" />
								</div>
							</div>
						</div>
					</div>
					<DialogBarNew
						dialog={
							"Una persona reparte el dinero a diferentes personas y las instruye para que hagan depósitos de montos pequeños a una cuenta."
						}
						callback={() => {
							setUiToShow(steps.cardTwo);
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T4.sub06.sub6_act1_a03)
						}}
					></DialogBarNew>
				</>
			)}
			{uiToShow === steps.cardTwo && (
				<>
					<div className="fixed z-10 bg-[#00000074] h-full w-full"></div>
					<div className="fixed z-10 h-full w-full pt-12 flex justify-center items-center">
						<div className="w-[224px] h-[280px] md:w-[450px] md:h-[600px] gradiantBlueClient rounded-2xl border-[1px] border-white p-2">
							<div className="bg-red_primary w-full h-[32px] md:h-[40px] rounded-lg flex justify-center items-center">
								<p className="text-white text-[14px] md:text-[24px]">Diversificación</p>
							</div>
							<div className="h-[calc(100%-32px)] md:h-[calc(100%-40px)] md:p-7">
								<div className="w-full h-full py-3">
									<img className="h-full w-full object-contain" src={imgsTopic4.manCardTwo} alt="Hombre con dinero" />
								</div>
							</div>
						</div>
					</div>
					<DialogBarNew
						dialog={
							"Una persona hace transferencias a varias cuentas para disolver el dinero y dificultar su rastreo."
						}
						callback={() => {
							setUiToShow(steps.cardThree);
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T4.sub06.sub6_act1_a04)
						}}
					></DialogBarNew>
				</>
			)}
			{uiToShow === steps.cardThree && (
				<>
					<div className="fixed z-10 bg-[#00000074] h-full w-full"></div>
					<div className="fixed z-10 h-full w-full pt-12 flex justify-center items-center">
						<div className="w-[224px] h-[280px] md:w-[450px] md:h-[600px] gradiantBlueClient rounded-2xl border-[1px] border-white p-2">
							<div className="bg-red_primary w-full h-[32px] md:h-[40px] rounded-lg flex justify-center items-center">
								<p className="text-white text-[14px] md:text-[24px]">Integración</p>
							</div>
							<div className="h-[calc(100%-32px)] md:h-[calc(100%-40px)] md:p-7">
								<div className="w-full h-full py-3">
									<img className="h-full w-full object-contain" src={imgsTopic4.manCardThree} alt="Hombre rico" />
								</div>
							</div>
						</div>
					</div>
					<DialogBarNew
						dialog={
							"Una persona compra y vende autos de lujo, casas, pinturas de arte, joyas preciosas, etc. De esta forma justifica el origen de los recursos."
						}
						callback={() => {
							ObserverEmitter.emit(EVENTS.tema4.subtopicOne.activityTwo.returnToDesk)
							ObserverEmitter.emit(EVENTS.audiosEvents.controlVoices, voicesTypeControl.stop)
							setUiToShow(steps.win);
						}}
					></DialogBarNew>
				</>
			)}
			{uiToShow === steps.win && (
				<>
					<div className="fixed z-10 bg-[#00000074] h-full w-full"></div>
					<ValidationResultModal
						title="¡Bien hecho!"
						numberPoints={0}
						dialogModal="Lleva a la práctica lo que has aprendido ya que estas acciones te permitirán crecer y destacarte en tu trabajo."
						buttonTxt="Continuar"
						isCorrect={true}
						action={() => {
							dispatch(
								completeOneTask({
									idActivity: 1,
									pointsWin: 0,
									subtema: tasksId.tema4.activities.subtema6,
								})
							);
							navigation("/home4/tema4/subtema6/activityTwo");
						}}
					/>
				</>
			)}
		</>
	)
}
